import {
  View,
  Text,
  StyleSheet,
  Modal,
  ScrollView,
  FlatList,
  Dimensions,
  PixelRatio,
  BackHandler,
  ActivityIndicator,
  Platform,
} from "react-native";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import Colours from "../../utils/Colours";
import { TouchableOpacity } from "react-native";
import PublicProfile from "../publicProfile/PublicProfile";
import Carousel from "react-native-reanimated-carousel";
import { Image } from "expo-image";
import Comments from "../../icons/Comments";
import AppTextInput from "../../utils/ColourThemes/AppTextInput";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Ionicons } from "@expo/vector-icons";
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";
import CommentComponent from "../../commentComponent/CommentComponent";
import { useNavigation } from "expo-router";
import { useFocusEffect, useRoute } from "@react-navigation/native";
import { SafeAreaView } from "react-native-safe-area-context";
import { BASE_URL, FRONTEND_URL } from "../../api/axios"; // Your Axios file
import * as Clipboard from "expo-clipboard";

const { width, height } = Dimensions.get("window");
const dpr = Math.round(PixelRatio.get() || 1);
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;
const VAL_NAME = "dxfdmlk0f";
const MAX_RETRIEZ = 20;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const dynamicTableUsersImgHeight = Math.round(width * 0.12);
const dynamicTableUsersImgWidth = Math.round(width * 0.12);
const dynamicTableImgObjWidth = Math.round((width / BASE_WIDTH) * 60);
const dynamicTableImgObjHeight = Math.round((width / BASE_WIDTH) * 60);

// const stageStartTracker = {};

const ADoingScreen = ({ fromTableHashTag }) => {
  const [showPublicProfile, setShowPublicProfile] = useState(false);
  const [showViewImages, setShowViewImages] = useState(false);
  const [selectedList, setSelectedList] = useState(null);
  const [initialIndex, setInitialIndex] = useState(0);
  const [selectedImg, setSelectedImg] = useState(null);
  const [userData, setUserData] = useState(null);

  const [isCommentSent, setIsCommentSent] = useState(false);
  const [commentText, setCommentText] = useState("");
  const [isCommentFocused, setIsCommentFocused] = useState(false);
  const [isLoadingComment, setIsLoadingComment] = useState(false);
  const [commentCount, setCommentCount] = useState(0);
  const [showComments, setShowComments] = useState(false);

  const [isCopied, setIsCopied] = useState(false);

  const [tableComments, setTableComments] = useState([]);
  const [tableCommentsReplies, setTableCommentsReplies] = useState([]);

  const [retryCount, setRetryCount] = useState(0);
  const [imageKey, setImageKey] = useState(0);

  const navigation = useNavigation();
  const route = useRoute();
  const { selectedTable, fromTableProfileView, mode } = route.params || {};

  const [activeTable, setActiveTable] = useState(selectedTable);
  const axiosPrivate = useAxiosPrivate();

  // Fetch fresh table data function
  const fetchLatestTableData = async () => {
    try {
      const tableId = selectedTable?._id;
      if (!tableId) return;

      const response = await axiosPrivate.get(`/veryRecentVirtualTables/${tableId}`);
      const updatedTable = response.data?.data;

      if (updatedTable) {
        setActiveTable(updatedTable);
      }
    } catch (error) {
      console.error("Error fetching live table status:", error?.response?.data || error.message);
    }
  };

  const handleCopyLink = async () => {
    const shareableLink = activeTable ? `${FRONTEND_URL}/join/${activeTable.tableToken}` : "";

    if (!shareableLink) return;

    try {
      // Works across Web, Expo, and React Native
      if (Platform.OS === "web" && navigator.clipboard) {
        await navigator.clipboard.writeText(shareableLink);
      } else if (Clipboard?.setStringAsync) {
        await Clipboard.setStringAsync(shareableLink);
      }

      // Trigger Success UI feedback
      setIsCopied(true);

      // Revert back after 2 seconds
      setTimeout(() => {
        setIsCopied(false);
      }, 2000);
    } catch (error) {
      console.error("Failed to copy link:", error);
    }
  };

  // Poll every 5 seconds while screen is focused
  useFocusEffect(
    useCallback(() => {
      fetchLatestTableData();

      const intervalId = setInterval(() => {
        fetchLatestTableData();
      }, 5000);

      return () => clearInterval(intervalId);
    }, [selectedTable?._id]),
  );

  // Safely memoize the data grid array so it can be re-used directly by the Carousel
  const joinedGuestsImages = useMemo(() => {
    return (activeTable?.joinedGuests || []).flatMap((guest) => guest?.images || []);
  }, [activeTable?.joinedGuests]);

  // Dynamically resolve the carousel array based on the list key selected
  const currentImageList = useMemo(() => {
    if (selectedList === "table") {
      return activeTable?.images || [];
    }
    if (selectedList === "contributions") {
      return joinedGuestsImages;
    }
    return [];
  }, [selectedList, activeTable?.images, joinedGuestsImages]);

  const formatCompactCurrency = (value) => {
    if (!value || isNaN(value)) return "₦0";

    if (value >= 1000000) {
      const rawMillions = value / 1000000;
      const truncated = Math.floor(rawMillions * 10) / 10;
      return `${truncated}M+`;
    }

    if (value >= 1000) {
      const rawThousands = value / 1000;
      const roundedTens = Math.floor(rawThousands / 10) * 10;
      return `${roundedTens}K+`;
    }

    return `${value}`;
  };

  const isServed = Boolean(activeTable?.tableServed);
  // console.log("isServed", isServed);

  const steps = [
    { key: "processing", label: "Processing" },
    { key: "processed", label: "Processed" },
    { key: "waiter_approaching", label: "Waiter Approaching" },
    { key: "served", label: "Served" },
  ];

  const SERVED_GREEN = "#10B981";

  const getStepIndex = (status) => {
    switch (status) {
      case "processing":
        return 0;
      case "processed":
        return 1;
      case "waiter_approaching":
        return 2;
      case "served":
        return 3;
      default:
        return 0;
    }
  };

  // Calculate minutes passed since the table was marked as served/processed by admin
  const minutesSinceServed =
    activeTable?.tableServed && activeTable?.updatedAt
      ? (Date.now() - new Date(activeTable.updatedAt).getTime()) / (1000 * 60)
      : 0;

  // Resolve stage based solely on tableServed boolean + time elapsed
  const resolveOrderStatus = () => {
    const isServedByAdmin = Boolean(activeTable?.tableServed);

    if (!isServedByAdmin) {
      return "processing";
    }

    if (minutesSinceServed >= 5) {
      return "served";
    }

    if (minutesSinceServed >= 1) {
      return "waiter_approaching";
    }

    return "processed";
  };

  const orderStatus = resolveOrderStatus();
  const currentStepIndex = getStepIndex(orderStatus);
  const isFullyServed = orderStatus === "served";

  // Derive stage start timestamp directly from server timestamps (createdAt / updatedAt)
  const createdAtTime = activeTable?.createdAt
    ? new Date(activeTable.createdAt).getTime()
    : Date.now();
  const updatedAtTime = activeTable?.updatedAt
    ? new Date(activeTable.updatedAt).getTime()
    : Date.now();

  const getCurrentStageStartTime = () => {
    if (!activeTable?.tableServed) {
      // 'processing': started when table was created
      return createdAtTime;
    }
    if (minutesSinceServed >= 5) {
      return 0; // 'served'
    }

    if (minutesSinceServed >= 1) {
      // 'waiter_approaching': started 1 minute after table served flag was set
      return updatedAtTime + 1 * 60 * 1000;
    }

    // 'processed': started exact time tableServed was updated
    return updatedAtTime;
  };

  const currentStageStartTime = getCurrentStageStartTime();

  // // Lock in start timestamp per stage so navigating away doesn't wipe progress
  // const tableId = activeTable?._id;
  // const stageKey = `${tableId}_${orderStatus}`;

  // if (tableId && !activeTable?.tableServed) {
  //   // Purge any old 'processed', 'waiter_approaching', or 'served' stage records for this table
  //   delete stageStartTracker[`${tableId}_processed`];
  //   delete stageStartTracker[`${tableId}_waiter_approaching`];
  //   delete stageStartTracker[`${tableId}_served`];
  // }

  // if (tableId && !stageStartTracker[stageKey]) {
  //   stageStartTracker[stageKey] = Date.now();
  // }

  // const currentStageStartTime = stageStartTracker[stageKey] || Date.now();

  // Helper to compute live elapsed seconds relative to stage start timestamp
  const calculateElapsedSeconds = useCallback(() => {
    if (isFullyServed) return 0;
    const diffInSeconds = Math.floor((Date.now() - currentStageStartTime) / 1000);
    return diffInSeconds > 0 ? diffInSeconds : 0;
  }, [currentStageStartTime, isFullyServed]);

  const [secondsElapsed, setSecondsElapsed] = useState(calculateElapsedSeconds);

  // Sync PWA timer continuously with real-time clock
  useEffect(() => {
    if (isFullyServed) {
      setSecondsElapsed(0);
      return;
    }

    setSecondsElapsed(calculateElapsedSeconds());

    const interval = setInterval(() => {
      setSecondsElapsed(calculateElapsedSeconds());
    }, 1000);

    return () => clearInterval(interval);
  }, [orderStatus, isFullyServed, calculateElapsedSeconds]);

  // Web/PWA Back Navigation Handler
  useEffect(() => {
    const handlePopState = () => {
      if (showPublicProfile) {
        setShowPublicProfile(false);
      } else if (showViewImages) {
        setShowViewImages(false);
      }
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [showPublicProfile, showViewImages]);

  useEffect(() => {
    const fetchCommentCount = async () => {
      const tableID = activeTable?._id;
      if (!tableID) return;

      try {
        const response = await axiosPrivate.get(`/getComments/getComments/${tableID}`);
        if (response.data?.success) {
          setCommentCount(response.data.commentCount);
          setTableComments(response.data.comments);
          setTableCommentsReplies(response.data.replies);
        }
      } catch (err) {
        // Handle error quietly
      }
    };

    fetchCommentCount();
  }, [activeTable?._id]);

  // Formats seconds into MM:SS string (e.g. 65 -> "01:05")
  // const formatTimer = (totalSeconds) => {
  //   const mins = Math.floor(totalSeconds / 60);
  //   const secs = totalSeconds % 60;
  //   return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  // };
  const formatTimer = (rawSeconds) => {
    // Ensure we have a valid positive integer
    const totalSeconds = Math.max(0, Math.floor(Number(rawSeconds) || 0));

    const hours = Math.floor(totalSeconds / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;

    const pad = (num) => num.toString().padStart(2, "0");

    // 1 hour or more -> H:MM:SS (e.g. "1:35:22" or "20:17:05")
    if (hours >= 1) {
      return `${hours}:${pad(mins)}:${pad(secs)}`;
    }

    // Under 1 hour -> MM:SS (e.g. "35:22")
    return `${pad(mins)}:${pad(secs)}`;
  };

  const getOptimizedCloudinaryUrl = (originalUrl, targetWidth, targetHeight) => {
    if (!originalUrl || !originalUrl.includes(VAL_NAME)) {
      return originalUrl;
    }

    const transformations = `w_${targetWidth},h_${targetHeight},c_fill,f_auto,q_90,dpr_${dpr}`;
    return originalUrl.replace(/upload\//, `upload/${transformations}/`);
  };

  const handleImageError = () => {
    if (retryCount < MAX_RETRIEZ) {
      setRetryCount((prevCount) => prevCount + 1);
      setImageKey((prevKey) => prevKey + 1);
    }
  };

  // Normalize contributions to maintain compatibility
  const theContributions = activeTable?.contributions || activeTable?.table?.contributions || [];

  const contributions = useMemo(() => {
    return [...theContributions].sort((a, b) => b.amount - a.amount);
  }, [theContributions]);

  const total_Contributions =
    activeTable?.totalContributions || activeTable?.table?.totalContributions || "";
  const table_Caption = activeTable?.tableCaption || activeTable?.table?.tableCaption || "";

  const handlePublicProfile = (selectedUser) => {
    setUserData(selectedUser);
    navigation.navigate("public_profile", { userData: selectedUser });
  };

  const handleImagePress = (index, listName) => {
    setInitialIndex(index);
    setSelectedList(listName);
    setShowViewImages(true);
  };

  const handleCarouselSnap = (index) => {
    if (index === currentImageList.length - 1) {
      setTimeout(() => {
        setShowViewImages(false);
      }, 300);
    }
  };

  const hasUnpaidOrders = (activeTable?.orders || []).some((order) => order.status === "pending");

  return (
    <SafeAreaView style={styles.screenWrapper}>
      {/* Locked Static Top Header */}
      <TopHeaderComponent
        headerText={mode === "activeTables" ? `Table - ${activeTable?.tableNumber || ""}` : "Table"}
        hideScreen={() => navigation.goBack()}
      />

      <ScrollView
        style={styles.componentStyle}
        contentContainerStyle={styles.scrollContentLayout}
        showsVerticalScrollIndicator={false}
      >
        {/* 1. ELEVATED METRIC HERO CARD */}
        <View style={styles.heroMetricCard}>
          <Text style={styles.tableCaptionTxt}>{activeTable?.tableName || "Active Table"}</Text>

          {/* Container to push financial metrics left and button right */}
          <View style={styles.heroMainRowLayout}>
            {/* LEFT SIDE: FINANCIAL METRICS */}
            <View style={styles.heroLeftMetricsColumn}>
              {mode === "activeTables" ? (
                <>
                  <Text style={styles.tableValueSubLabel}>MONEY ON THE TABLE</Text>
                  <View style={styles.moneyTotalTableValueContainer}>
                    <Text style={styles.tableValueAmtTxt}>
                      {activeTable?.estimatedTotalBill?.toLocaleString() || "_"}
                    </Text>
                  </View>
                </>
              ) : // ) : (activeTable?.totalSpentDoings ?? activeTable?.value ?? 0) < 100000 ? (
              mode === "active_Tables" ||
                (activeTable?.totalSpentDoings ?? activeTable?.value ?? 0) < 50000 ? (
                <>
                  <Text style={styles.tableValueSubLabel}>VOLTAGE</Text>
                  <View style={styles.moneyTotalTableValueContainer}>
                    <Text style={styles.tableValueAmtTxt}>{selectedTable?.volts ?? 0} Volts</Text>
                  </View>
                </>
              ) : (
                <>
                  <Text style={styles.tableValueSubLabel}>TABLE VALUE</Text>
                  <View style={styles.moneyTotalTableValueContainer}>
                    <Text style={styles.tableValueAmtTxt}>
                      {/* {formatCompactCurrency(activeTable?.totalSpentDoings)} */}
                      {formatCompactCurrency(activeTable?.totalSpentDoings ?? activeTable?.value)}
                    </Text>
                  </View>
                </>
              )}
            </View>

            {/* RIGHT SIDE: REVIEW & PAY BUTTON */}
            {mode === "activeTables" && (
              <TouchableOpacity
                style={styles.reviewPayRightButton}
                activeOpacity={0.8}
                onPress={() =>
                  navigation.navigate("reviewAndPay", {
                    selectedTable,
                  })
                }
              >
                <Text style={styles.reviewPayButtonText}>
                  {hasUnpaidOrders ? "Pay Now" : "Review Orders"}
                </Text>
              </TouchableOpacity>
            )}
          </View>
        </View>
        {/* ── LIVE ORDER TRACKING CARD ── */}
        {mode === "activeTables" && (
          <View style={styles.trackingCard}>
            {/* <Text style={styles.sectionText}>BAR</Text> */}

            <View style={styles.trackingHeaderRow}>
              <View style={styles.trackingTitleContainer}>
                <Ionicons
                  name="time-outline"
                  size={16}
                  color={isFullyServed ? SERVED_GREEN : Colours.PRIMARY}
                />
                <Text style={styles.trackingTitleTxt}>Order Tracking</Text>
                {/* Timer Counter: Displays in MM:SS, resets per stage, disappears on "Served" */}
                {!isFullyServed && (
                  <View style={styles.timerContainer}>
                    <Text style={styles.timerTxt}>{formatTimer(secondsElapsed)}</Text>
                  </View>
                )}
              </View>
              <Text
                style={[styles.trackingBadgeTxt, isFullyServed && styles.trackingBadgeServedTxt]}
              >
                {steps[currentStepIndex]?.label}
              </Text>
            </View>

            {/* Stepper Timeline Container */}
            <View style={styles.stepperContainer}>
              {steps.map((step, idx) => {
                const isCompleted = idx < currentStepIndex;
                const isCurrent = idx === currentStepIndex;
                const isUpcoming = idx > currentStepIndex;
                const isServedStep = step.key === "served";

                return (
                  <React.Fragment key={step.key}>
                    {/* Step Node Circle */}
                    <View style={styles.stepNodeWrapper}>
                      <View
                        style={[
                          styles.stepCircle,
                          isCompleted && styles.stepCircleCompleted,
                          isCurrent &&
                            (isServedStep ? styles.stepCircleServed : styles.stepCircleCurrent),
                          isUpcoming && styles.stepCircleUpcoming,
                        ]}
                      >
                        {isServedStep || isCompleted ? (
                          <Ionicons name="checkmark-sharp" size={13} color="#FFFFFF" />
                        ) : isCurrent ? (
                          <View style={styles.activePulseDot} />
                        ) : (
                          <View style={styles.upcomingDot} />
                        )}
                      </View>

                      {/* Step Label */}
                      <Text
                        style={[
                          styles.stepLabelTxt,
                          (isCompleted || isCurrent) && styles.stepLabelActiveTxt,
                          isServedStep && isCurrent && { color: SERVED_GREEN },
                        ]}
                        numberOfLines={2}
                      >
                        {step.label}
                      </Text>
                    </View>

                    {/* Connecting Line between Nodes */}
                    {idx < steps.length - 1 && (
                      <View
                        style={[
                          styles.stepConnectorLine,
                          idx < currentStepIndex &&
                            (idx === steps.length - 2 && currentStepIndex === steps.length - 1
                              ? styles.stepConnectorServed
                              : styles.stepConnectorActive),
                        ]}
                      />
                    )}
                  </React.Fragment>
                );
              })}
            </View>
          </View>
        )}
        {/* ── TOP UP & NEW ORDER CARD ── */}
        {mode === "activeTables" && (
          <></>
          // <View style={styles.topUpActionCard}>
          //   <View style={styles.topUpLeftInfo}>
          //     <Text style={styles.topUpTitleTxt}>Top up</Text>
          //     <Text style={styles.topUpSubTxt}>Add a new round of drinks or meals</Text>
          //   </View>

          //   <TouchableOpacity
          //     style={styles.newOrderButton}
          //     activeOpacity={0.85}
          //     onPress={() => {
          //       const tableId = activeTable?._id;
          //       if (typeof sessionStorage !== "undefined") {
          //         sessionStorage.setItem("is_topup_flow", "true");
          //       }
          //       navigation.navigate("brandMenu", { tableId, isTopUp: true });
          //     }}
          //   >
          //     <Text style={styles.newOrderBtnText}>New order</Text>
          //     <Ionicons name="add-circle-outline" size={16} color="#FFFFFF" />
          //   </TouchableOpacity>
          // </View>
        )}
        {/* ── TAG FRIENDS TO TABLE── */}
        {mode === "activeTables" && (
          <View style={styles.tagActionCard}>
            {/* Overlapping Badges symbolizing social tagging */}
            <View style={styles.tagAvatarWrapper}>
              <View style={styles.tagIconBadge}>
                <Ionicons name="pricetag" size={16} color={Colours.PRIMARY} />
              </View>
              <View style={[styles.tagIconBadge, styles.tagIconBadgeOverlap]}>
                <Ionicons name="person-add" size={14} color="#0F172A" />
              </View>
            </View>

            {/* Text Section */}
            <View style={styles.tagTextContainer}>
              <Text style={styles.tagTitleTxt}>Add Friends</Text>
              <Text style={styles.tagSubTxt}>
                Add Friends to this table, copy and share the link.
              </Text>
            </View>

            {/* Modern Pill Action Button */}
            {/* Dynamic Copy Button */}
            <TouchableOpacity
              style={[
                styles.tagActionButton,
                isCopied && styles.tagActionButtonSuccess, // Green state background override
              ]}
              activeOpacity={0.8}
              onPress={handleCopyLink}
            >
              <Ionicons
                name={isCopied ? "checkmark-sharp" : "copy-outline"}
                size={15}
                color="#FFFFFF"
              />
              <Text style={styles.tagActionBtnText}>{isCopied ? "Copied!" : "Copy"}</Text>
            </TouchableOpacity>
          </View>
        )}

        {/* 2. ELEVATED CONTRIBUTIONS / DOINGS LIST CARD */}
        <View style={styles.elevatedSectionCard}>
          <View style={styles.sectionHeaderRow}>
            <Ionicons
              name="flash-outline"
              size={16}
              color={Colours.PRIMARY}
              style={{ marginRight: 6 }}
            />
            <Text style={styles.doingzTxt}>Doings</Text>
            <Text style={styles.verticalSecton}>|</Text>
            <Text style={styles.topOnTableTxt}>ON THE TABLE</Text>
          </View>

          {activeTable?.isAnonymous ? (
            /* Render single non-clickable item for Anonymous Tables */
            <View style={[styles.profileRowItem, { borderBottomWidth: 0 }]}>
              <Image
                source={{
                  uri: `https://api.dicebear.com/7.x/pixel-art/svg?seed=${
                    activeTable?._id || activeTable?.id || "anonymous"
                  }`,
                }}
                style={[styles.userImage, { backgroundColor: "#f0f0f2" }]}
                contentFit="cover"
                borderRadius={20}
                cachePolicy="disk"
              />
              <View style={styles.profileTextContainer}>
                <Text style={styles.usernameTxt}>
                  @{`guest_${(activeTable?._id || activeTable?.id || "anon").toString().slice(-8)}`}
                </Text>
              </View>
            </View>
          ) : (
            <FlatList
              data={activeTable?.joinedGuests || []}
              keyExtractor={(item) => (item?._id ? item._id.toString() : Math.random().toString())}
              scrollEnabled={false}
              renderItem={({ item: user, index }) => {
                const tableUsersImgUrl = user?.profilePicture || "";
                const newTableUsersImgUrl = getOptimizedCloudinaryUrl(
                  tableUsersImgUrl,
                  dynamicTableUsersImgHeight,
                  dynamicTableUsersImgWidth,
                );

                return (
                  <TouchableOpacity
                    style={[
                      styles.profileRowItem,
                      index === (activeTable?.joinedGuests?.length || 0) - 1 && {
                        borderBottomWidth: 0,
                      },
                    ]}
                    activeOpacity={0.7}
                    onPress={() => handlePublicProfile(user)}
                  >
                    <Image
                      key={imageKey}
                      source={{ uri: newTableUsersImgUrl }}
                      style={[styles.userImage, { backgroundColor: "#f0f0f2" }]}
                      contentFit="cover"
                      borderRadius={20}
                      cachePolicy="disk"
                      onError={handleImageError}
                    />
                    <View style={styles.profileTextContainer}>
                      <Text style={styles.usernameTxt}>@{user?.username || "anonymous"}</Text>
                    </View>
                    <Ionicons name="chevron-forward" size={14} color="#C7C7CC" />
                  </TouchableOpacity>
                );
              }}
            />
          )}
        </View>
        {/* 3. ELEVATED GALLERY MEDIA CARD */}
        {!activeTable?.isAnonymous && (
          <View style={styles.elevatedSectionCard}>
            <View style={[styles.sectionHeaderRow, { marginBottom: 14 }]}>
              <Ionicons
                name="images-outline"
                size={16}
                color={Colours.PRIMARY}
                style={{ marginRight: 6 }}
              />
              <Text style={styles.fromTableCationText}>FROM THE TABLE</Text>
            </View>

            <View style={styles.galleryGridContainer}>
              {joinedGuestsImages.map((imageObj, index) => {
                const tableImgUrl = imageObj?.url;
                if (!tableImgUrl) return null;

                const newTableImgUrl = getOptimizedCloudinaryUrl(
                  tableImgUrl,
                  dynamicTableImgObjHeight,
                  dynamicTableImgObjWidth,
                );

                return (
                  <TouchableOpacity
                    key={`contrib-img-${index}`}
                    style={styles.galleryImageTouchable}
                    activeOpacity={0.9}
                    onPress={() => handleImagePress(index, "contributions")}
                  >
                    <Image
                      key={`grid-img-${imageObj._id || index}-${imageKey}`}
                      source={{ uri: newTableImgUrl }}
                      style={[styles.picImageContr, { backgroundColor: "#f0f0f2" }]}
                      contentFit="cover"
                      cachePolicy="disk"
                      onError={handleImageError}
                    />
                  </TouchableOpacity>
                );
              })}
            </View>
          </View>
        )}
      </ScrollView>

      {/* ================= MODAL LAYERS ================= */}
      <Modal
        animationType="fade"
        visible={showPublicProfile}
        onRequestClose={() => setShowPublicProfile(false)}
      >
        <View style={{ flex: 1, backgroundColor: Colours.LIGHTEST }}>
          <PublicProfile setShowPublicProfile={setShowPublicProfile} userData={userData} />
        </View>
      </Modal>

      <Modal
        animationType="fade"
        visible={showViewImages}
        transparent
        onRequestClose={() => setShowViewImages(false)}
      >
        <View style={styles.modalContainer}>
          {currentImageList.length > 0 && (
            <Carousel
              width={width}
              height={height}
              data={currentImageList}
              renderItem={({ item, index }) => {
                const tablelFullImgUrl = typeof item === "string" ? item : item?.url;
                if (!tablelFullImgUrl) return null;

                const newTablelFullImgUrl = getOptimizedCloudinaryUrl(
                  tablelFullImgUrl,
                  Math.round(width),
                  Math.round(height),
                );

                return (
                  <View style={styles.fullScreenImageContainer} key={`carousel-pane-${index}`}>
                    <Image
                      key={`carousel-img-${index}-${imageKey}`}
                      source={{ uri: newTablelFullImgUrl }}
                      style={[styles.fullScreenImage, { backgroundColor: "#1A1A1A" }]}
                      contentFit="cover"
                      cachePolicy="disk"
                      onError={handleImageError}
                    />
                  </View>
                );
              }}
              vertical={true}
              loop={false}
              defaultIndex={initialIndex}
              pagingEnabled={true}
              onSnapToItem={handleCarouselSnap}
            />
          )}
        </View>
      </Modal>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  screenWrapper: {
    flex: 1,
    backgroundColor: "#F8F9FC", // Soft off-white backdrop provides premium card contrast
  },

  componentStyle: {
    flex: 1,
  },

  scrollContentLayout: {
    flexGrow: 1,
    paddingHorizontal: 16,
    paddingTop: 16,
    paddingBottom: 120, // Extra margin breathing space for active scrolling content
  },

  heroMainRowLayout: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: 8,
  },
  heroLeftMetricsColumn: {
    flex: 1, // Takes up the available space on the left side
  },
  reviewPayRightButton: {
    backgroundColor: Colours.PRIMARY,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 10,
    paddingHorizontal: 16,
    borderRadius: 10,
    alignSelf: "center",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
    elevation: 2,
  },
  reviewPayButtonText: {
    color: "#FFFFFF",
    fontSize: 14,
    fontWeight: "700",
  },

  heroMetricCard: {
    backgroundColor: "#FFFFFF", // Changed from solid primary red to crisp clean white
    borderRadius: 16,
    padding: 20,
    marginBottom: 16,
    borderLeftWidth: 4, // Elegant classic touch: subtle red indicator bar on the left edge
    borderLeftColor: Colours.PRIMARY,

    // Smooth Clean Classic Shadow matching the rest of the UI
    shadowColor: "#000000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.04,
    shadowRadius: 8,
    elevation: 2,
  },

  tableCaptionTxt: {
    fontSize: 15,
    fontFamily: "Sen-Bold",
    color: "#1A1A1A", // Changed from white to premium dark charcoal text
    textTransform: "uppercase",
    letterSpacing: 0.5,
    marginBottom: 12,
  },

  tableValueSubLabel: {
    fontSize: 11,
    fontFamily: "Sen-Medium",
    color: Colours.DARKLIGHTGRAY, // Changed from translucent white to a soft muted gray
    letterSpacing: 0.8,
  },

  topUpActionCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: 16,
    padding: 16,
    marginVertical: 12, // Provides consistent visual breathing room between cards
    flexDirection: "row",
    justifyContent: "space-between", // Pushes text left and button right
    alignItems: "center",
    borderWidth: 1,
    borderColor: "#F2F2F2",
    // Clean elevated shadow structure
    elevation: 3,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 6,
  },

  topUpLeftInfo: {
    flex: 1,
    paddingRight: 12,
  },
  topUpTitleTxt: {
    fontFamily: "Sen-Bold",
    fontSize: 16,
    color: "#1A1A1A",
    marginBottom: 2,
  },
  topUpSubTxt: {
    fontFamily: "Sen-Regular",
    fontSize: 12,
    color: "#777777",
  },
  newOrderButton: {
    backgroundColor: Colours.DARKGRAY, // Solid modern dark background contrasting reviewPay
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderRadius: 12,
    gap: 6,
  },
  newOrderBtnText: {
    color: "#FFFFFF",
    fontFamily: "Sen-Bold",
    fontSize: 14,
  },

  tagActionCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: 20,
    paddingVertical: 12,
    paddingHorizontal: 16,
    marginBottom: 12,
    flexDirection: "row",
    alignItems: "center",
    borderWidth: 1,
    borderColor: "#F1F5F9",
    // Ambient drop shadow
    elevation: 4,
    shadowColor: "#0F172A",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.05,
    shadowRadius: 12,
  },

  tagAvatarWrapper: {
    flexDirection: "row",
    alignItems: "center",
    marginRight: 12,
  },

  tagIconBadge: {
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: Colours.PRIMARY ? `${Colours.PRIMARY}18` : "#F8FAFC",
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 2,
    borderColor: "#FFFFFF",
  },

  tagIconBadgeOverlap: {
    backgroundColor: "#F1F5F9",
    marginLeft: -12, // Overlapping avatar stack
  },

  tagTextContainer: {
    flex: 1,
    paddingRight: 8,
  },

  tagTitleTxt: {
    fontFamily: "Sen-Bold",
    fontSize: 15,
    color: "#0F172A",
    letterSpacing: -0.2,
    marginBottom: 1,
  },

  tagSubTxt: {
    fontFamily: "Sen-Regular",
    fontSize: 12,
    color: "#64748B",
  },

  tagActionButton: {
    backgroundColor: Colours.DARKGRAY, // Dark Slate contrast
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 14,
    paddingVertical: 8,
    borderRadius: 12, // Capsule / Pill shape
    gap: 3,
    shadowColor: Colours.DARKGRAY,
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.15,
    shadowRadius: 4,
    elevation: 2,
  },

  tagActionButtonSuccess: {
    backgroundColor: "#10B981", // Emerald Green
    shadowColor: "#10B981",
  },

  tagActionBtnText: {
    color: "#FFFFFF",
    fontFamily: "Sen-Bold",
    fontSize: 13,
    letterSpacing: 0.2,
  },

  moneyTotalTableValueContainer: {
    marginTop: 4,
  },

  tableValueAmtTxt: {
    fontSize: 28,
    fontFamily: "Sen-Bold",
    color: Colours.PRIMARY, // The actual money values are now accented beautifully in your primary color
    letterSpacing: -0.5,
  },

  // ... Keep the rest of your stylesheet components exactly as they were!

  /* 2. Structured Section Cards (Cast Elevated Shadows) */
  elevatedSectionCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: 16,
    padding: 16,
    marginBottom: 16,

    // Smooth Clean Classic Shadow
    shadowColor: "#000000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.04,
    shadowRadius: 8,
    elevation: 2,
  },

  sectionHeaderRow: {
    flexDirection: "row",
    alignItems: "center",
    paddingBottom: 12,
    borderBottomWidth: 1,
    borderBottomColor: "#F1F2F6",
  },

  doingzTxt: {
    fontSize: 14,
    fontFamily: "Sen-Bold",
    color: "#1A1A1A",
  },

  verticalSecton: {
    fontSize: 14,
    color: "#E4E7EB",
    marginHorizontal: 6,
  },

  topOnTableTxt: {
    fontSize: 12,
    fontFamily: "Sen-Medium",
    color: Colours.DARKLIGHTGRAY,
    letterSpacing: 0.3,
  },

  fromTableCationText: {
    fontSize: 12,
    fontFamily: "Sen-Bold",
    color: "#1A1A1A",
    letterSpacing: 0.5,
  },

  /* 3. Refined Row Render Items */
  profileRowItem: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 12,
    borderBottomWidth: 0.5,
    borderBottomColor: "#F1F2F6",
  },

  userImage: {
    width: 40,
    height: 40,
    borderRadius: 20,
    borderWidth: 1.5,
    borderColor: "#FFFFFF",
  },

  profileTextContainer: {
    flex: 1,
    marginLeft: 12,
  },

  usernameTxt: {
    fontSize: 14,
    fontFamily: "Sen-Bold",
    color: "#1A1A1A",
  },

  /* 4. Elegant Picture Gallery Grids */
  galleryGridContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginHorizontal: -4, // Counterbalance inner picture offsets cleanly
  },

  galleryImageTouchable: {
    width: "25%", // Evenly spaced 4-column item grids
    aspectRatio: 1,
    padding: 4,
  },

  picImageContr: {
    width: "100%",
    height: "100%",
    borderRadius: 15, // Modern classic squircle image card corners
  },

  /* Modal Layout Backdrops */
  modalContainer: {
    flex: 1,
    backgroundColor: "#000000",
    justifyContent: "center",
    alignItems: "center",
  },

  fullScreenImageContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },

  fullScreenImage: {
    width: "100%",
    height: "100%",
  },

  /****Order Tracking section */
  /* Order Tracking Styles */
  trackingCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: 16,
    padding: 16,
    marginTop: 4,
    marginBottom: 8,
    borderWidth: 1,
    borderColor: "#F2F2F2",
    shadowColor: "#000000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.04,
    shadowRadius: 6,
    elevation: 2,
  },

  trackingHeaderRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
  },

  trackingTitleContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },

  trackingTitleTxt: {
    fontFamily: "Sen-Bold",
    fontSize: 15,
    color: "#1A1A1A",
  },
  sectionText: {
    fontFamily: "Sen-Regular",
    fontSize: 13,
    color: Colours.DARKLIGHTGRAY,
    marginBottom: dynamicSpacing(10),
  },

  trackingBadgeTxt: {
    fontFamily: "Sen-Bold",
    fontSize: 11,
    color: Colours.PRIMARY,
    backgroundColor: "#FFF2F2", // Light tint matching primary theme
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 6,
    textTransform: "uppercase",
  },

  stepperContainer: {
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
    paddingHorizontal: 4,
  },

  stepNodeWrapper: {
    alignItems: "center",
    width: 60,
  },

  stepCircle: {
    width: 24,
    height: 24,
    borderRadius: 12,
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 8,
    borderWidth: 2,
  },

  stepCircleCompleted: {
    backgroundColor: Colours.PRIMARY,
    borderColor: Colours.PRIMARY,
  },

  stepCircleCurrent: {
    backgroundColor: "#FFFFFF",
    borderColor: Colours.PRIMARY,
  },

  stepCircleUpcoming: {
    backgroundColor: "#FFFFFF",
    borderColor: "#E0E0E0",
  },

  activePulseDot: {
    width: 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: Colours.PRIMARY,
  },

  upcomingDot: {
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: "#D0D0D0",
  },

  stepLabelTxt: {
    fontFamily: "Sen-Medium",
    fontSize: 10,
    color: "#999999",
    textAlign: "center",
    lineHeight: 12,
  },

  stepLabelActiveTxt: {
    fontFamily: "Sen-Bold",
    color: "#1A1A1A",
    fontSize: 10,
  },

  stepConnectorLine: {
    flex: 1,
    height: 2,
    backgroundColor: "#E0E0E0",
    marginTop: 11, // Vertically centers with the 24px circle
    marginHorizontal: -8,
  },

  stepConnectorActive: {
    backgroundColor: Colours.PRIMARY,
  },

  /* Tracking Badge Served State */
  trackingBadgeServedTxt: {
    color: "#10B981",
    backgroundColor: "#E6F4EA", // Soft green background tint
  },

  /* Circle States */
  stepCircleServed: {
    backgroundColor: "#10B981",
    borderColor: "#10B981",
  },

  stepConnectorServed: {
    backgroundColor: "#10B981",
  },

  /* Live Stage Timer Badge */
  timerContainer: {
    backgroundColor: "#F1F2F6",
    paddingHorizontal: 7,
    paddingVertical: 2,
    borderRadius: 6,
    marginLeft: 6,
  },

  timerTxt: {
    fontFamily: "Sen-Bold",
    fontSize: 12,
    color: "#555555",
    letterSpacing: 0.5,
  },
});

export default ADoingScreen;
